import { useEffect } from "react";
import useSupportStore from "../../stores/useSupportStore";

function formatDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleDateString() + " " + d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

const TicketList = () => {
  const { tickets, isLoading, loadTickets, selectTicket } = useSupportStore();

  useEffect(() => {
    loadTickets();
  }, []);

  if (isLoading) {
    return <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Loading...</div>;
  }

  if (tickets.length === 0) {
    return (
      <div className="support-empty">
        <div className="support-empty-icon">&#x1F3AB;</div>
        <div>No tickets yet</div>
        <div style={{ fontSize: 12, marginTop: 4 }}>Use the "Report Issue" button to create one</div>
      </div>
    );
  }

  return (
    <div>
      {tickets.map((ticket) => (
        <div
          key={ticket.localId}
          className="support-ticket-row"
          onClick={() => selectTicket(ticket.localId)}
        >
          <div className="support-ticket-header">
            <span className="support-ticket-subject">{ticket.subject}</span>
            <span className={`support-badge ${ticket.status}`}>{ticket.status.replace(/_/g, " ")}</span>
          </div>
          <div className="support-ticket-meta">
            <span className={`support-badge ${ticket.priority}`} style={{ marginRight: 8 }}>
              {ticket.priority}
            </span>
            <span>{ticket.category}</span>
            {ticket.ticketNumber && (
              <span style={{ marginLeft: 8, fontFamily: "monospace" }}>{ticket.ticketNumber}</span>
            )}
            <span style={{ float: "right" }}>{formatDate(ticket.createdAt)}</span>
          </div>
          {ticket.syncStatus === "pending" && (
            <div style={{ fontSize: 11, color: "#f57f17", marginTop: 4 }}>Pending sync...</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TicketList;
